module.exports = __webpack_public_path__ + "img/Assurance-Extra-Redundancy.726a8a6c.jpg";